import { getSalesTotalBreakdownLineItems, getSalePaymentLineItem, getSaleTotalLineItem, getSaleProductLineItem } from "../utils/sale-breakdown.utils/index.js";
export default function saleBreakDownFactory(_ref) {
  var saleStore = _ref.saleStore;
  var includeTotalWithVat = saleStore.includeTotalWithVat,
    payments = saleStore.payments,
    saleDisplaytotal = saleStore.saleDisplaytotal,
    bookings = saleStore.bookings,
    cartsObject = saleStore.cartsObject,
    carts = saleStore.carts,
    hasMultiCart = saleStore.hasMultiCart,
    saleNumber = saleStore.saleNumber;
  var keyToReadPrice = includeTotalWithVat ? 'totalWithVat' : 'subTotal';
  var saleProductList = getSaleProductLineItem(saleNumber, saleDisplaytotal.currency, bookings, cartsObject, carts);
  var salePaymentLineItem = getSalePaymentLineItem(payments, keyToReadPrice, saleDisplaytotal.currency, saleDisplaytotal, hasMultiCart);
  var saleTotalBreakDownLineItem = getSalesTotalBreakdownLineItems(saleDisplaytotal);
  var saleTotalLineItem = getSaleTotalLineItem(saleDisplaytotal, saleNumber);
  return {
    includeTotalWithVat: includeTotalWithVat,
    saleProductList: saleProductList,
    salePaymentLineItem: salePaymentLineItem,
    saleTotalBreakDownLineItem: saleTotalBreakDownLineItem,
    saleTotalLineItem: saleTotalLineItem
  };
}